<template>
  <div>
    <div class="mb-6 flex justify-between items-center">
      <h1 class="mb-8 font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('organizations')">Stores</inertia-link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ form.name }}
      </h1>
      <trashed-message v-if="organization.deleted_at" class="mb-6" @restore="restore"> Questo Store è stato cancellato.
      </trashed-message>
      <a v-if="authUser.id == 1 || authUser.id == 3 || authUser.id == 18 || authUser.id == 27" class="btn-indigo"
        :href="route('exportProductsStore', [this.organization.id, this.organization.name])">
        <span>Esporta</span>
        <span class="hidden md:inline">Prodotti</span>
      </a>
      <a v-if="authUser.id == 1 || authUser.id == 18 || authUser.id == 27" class="btn-indigo"
        :href="route('exportSalesProductsStore', [this.organization.id, this.organization.name])">
        <span>Esporta</span>
        <span class="hidden md:inline">Prodotti Venduti</span>
      </a>
    </div>
    <div v-if="authUser.id == 1 || authUser.id == 18 || authUser.id == 21 || authUser.id == 27"
      class="bg-white rounded-md shadow max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nome" />
          <text-input v-model="form.discount" :error="form.errors.discount" class="pr-6 pb-8 w-full lg:w-1/2"
            label="Sconto" />
          <multiselect v-model="form.user_ids" :options="usersList" placeholder="Seleziona utenti" label="full_name"
            track-by="id" multiple />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <!-- <button v-if="!organization.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Cancella Store</button> -->
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Aggiorna
            Store</loading-button>
        </div>
      </form>
    </div>
    <h2 class="mt-12 font-bold text-2xl">Lotti</h2>
    <div class="mt-6 bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nome</th>
          <th class="px-6 pt-6 pb-4">Data Carico</th>
          <th class="px-6 pt-6 pb-4">Data Scarico</th>
          <th class="px-6 pt-6 pb-4">Numero Prodotti</th>
        </tr>
        <tr v-for="batch in organization.batches" :key="batch.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500"
              :href="route('batches.edit', batch.id)">
              {{ batch.nome }}
              <icon v-if="batch.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('batches.edit', batch.id)" tabindex="-1">
              {{ batch.data_carico }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('batches.edit', batch.id)" tabindex="-1">
              {{ batch.data_scarico }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('batches.edit', batch.id)" tabindex="-1">
              {{ batch.products_count }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('batches.edit', batch.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="organization.batches.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Nessun lotto trovato.</td>
        </tr>
      </table>
    </div>
    <!-- <h2 class="mt-12 font-bold text-2xl">Prodotti</h2>
    <div class="mt-6 bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nome</th>
        </tr>
        <tr v-for="product in products" :key="product.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
              {{ product.name }}
          </td>
        </tr>
        <tr v-if="products.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Nessun prodotto trovato.</td>
        </tr>
      </table>
    </div> -->
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Multiselect from 'vue-multiselect'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Multiselect,
  },
  layout: Layout,
  props: {
    organization: Object,
    products: Object,
    users: Array,
    associatedUsers: Array,
  },
  remember: 'form',
  data() {
    return {
      selectedUsers: [],
      form: this.$inertia.form({
        name: this.organization.name,
        discount: this.organization.discount,
        user_ids: this.associatedUsers || [],
      }),
    }
  },
  computed: {
    authUser() {
      return this.$page.props.auth.user;
    },
    usersList() {
      return this.users.map(user => ({
        ...user,
        full_name: `${user.first_name} ${user.last_name}`,
      }))
    },
  },
  methods: {
    update() {
      this.form.put(this.route('organizations.update', this.organization.id))
    },
    destroy() {
      if (confirm('Vuoi eliminare questo Store?')) {
        this.$inertia.delete(this.route('organizations.destroy', this.organization.id))
      }
    },
    restore() {
      if (confirm('Vuoi ripristinare questo Store?')) {
        this.$inertia.put(this.route('organizations.restore', this.organization.id))
      }
    },
  },
}
</script>
